export enum PopupTheme {
  ACCENT = 'accent',
  AUTO_HEIGHT = 'auto-height',
  AUTO_WIDTH = 'auto-width',
  AUTO_WIDTH_MOBILE = 'auto-width-mobile',
  FULL_SCREEN = 'full-screen',
  INDENT = 'indent',
  TITLE_IN_BODY = 'title-in-body',
}
